export default __webpack_public_path__ + "static/plp--anejo--hover-5f1f99e4b119e9b37a3a8a13547e2c41.jpg";